import { NON_CORE_SECTION_SCORES_MAP } from "../config";
import { ResumeAnalysis } from "../resume-analysis/resume-analyse-types";
import { getStatementScore } from "../statment-analysis-scoring";



export const getCustomSectionScore = (custom: ResumeAnalysis["custom"], maxScoreOfSection: number): {
  totalScore: number;
  descriptionScore: number;
} => {
  const numberOfDescriptions = custom.descriptionAnalysis.length;
  const scorePerDescription = maxScoreOfSection * NON_CORE_SECTION_SCORES_MAP.customSection.statementWeight / (numberOfDescriptions);
  let descriptionScore = 0;
  custom.descriptionAnalysis.forEach((description) => {
    const descriptionAnalysisScore = getStatementScore(description.analysis, scorePerDescription);
    descriptionScore += descriptionAnalysisScore.totalScore;

  })
  return {
    totalScore: descriptionScore,
    descriptionScore
  };
}
